import React, { useEffect } from "react";
import {
  DeactivateButton,
  InfoDescription,
  InfoTitle,
  ProfileDetailItem,
  ProfileInfo,
  ProfileName,
  ShopDetailsContainer,
} from "../../styles/profile";

import { FormSubTitle } from "../../styles/PersonalInfoStep";
import { alertMessage } from "../../services/alertService";
import { ALERT_TITLES, ROUTES } from "../../constants";
import { POST } from "../../services/HTTPServices";
import { useNavigate } from "react-router-dom";
import Info from "../../assets/svgs/Dashboard/info.svg";

import DeactivationModal from "../../components/profile/DeactivationModal";
import DeleteAccountModal from "../../components/profile/DeleteAccountModal";
import { logout } from "../../services/auth.service";
import {
  LoadingOverlay,
  LoadingSpinner,
  LoadingSpinnerIcon,
} from "../../styles/loading";

const MyProfile: React.FC<any> = ({ formData, openingHours, onChange }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);

  const [auth, setAuth] = React.useState<any>(null);
  const [showDeactivateModal, setShowDeactivateModal] = React.useState(false);
  const [showDeleteModal, setShowDeleteModal] = React.useState(false);

  useEffect(() => {
    const authUser = JSON.parse(localStorage.getItem("authUser") || "null");
    if (authUser) {
      setAuth(authUser);
    }
  }, []);

  const deactivateUser = async (deactivationData: any) => {
    let resonsArr = [];
    for (let i = 0; i < deactivationData.reasons.length; i++) {
      resonsArr.push({
        serviceProviderId: auth.id,
        deReasonId: deactivationData.reasons[i].id,
        deType: 1,
        otherReason: "",
        createdUserId: auth.id.toString(),
      });
      if (i === deactivationData.reasons.length - 1) {
        let param = {
          id: auth.id,
          userId: auth.id.toString(),
          spDeReason: resonsArr,
        };

        let res: any = await POST(
          "serviceprovider/DeactivateServiceProvider",
          param,
          "provider"
        );

        if (res && res.status === 200) {
          setLoading(false);

          alertMessage(
            ALERT_TITLES.SUCCESS,
            "You deacivated your account successfully.You must login again."
          );
          await logout();
          navigate(ROUTES.LOGIN);
        } else {
          setLoading(false);
          if (res.status && res.status === 401) navigate("/unauthorized-page");
          else {
            alertMessage(ALERT_TITLES.ERROR, res.message);
          }
        }
      }
    }
  };

  const deleteUser = async (deactivationData: any) => {

    let resonsArr = [];
    for (let i = 0; i < deactivationData.reasons.length; i++) {
      resonsArr.push({
        serviceProviderId: auth.id,
        deReasonId: deactivationData.reasons[i].id,
        deType: 2,
        otherReason: deactivationData.otherReason,
        createdUserId: auth.id.toString(),
      });
      if (i === deactivationData.reasons.length - 1) {
        let param = {
          id: auth.id,
          userId: auth.id.toString(),
          spDeReason: resonsArr,
        };

        let res: any = await POST(
          "serviceprovider/DeleteServiceProvider",
          param,
          "provider"
        );

        if (res && res.status === 200) {
          setLoading(false);

          alertMessage(
            ALERT_TITLES.SUCCESS,
            "You deleted your account successfully.You must login again."
          );
          await logout();
          navigate(ROUTES.LOGIN);
        } else {
          setLoading(false);
          if (res.status && res.status === 401) navigate("/unauthorized-page");
          else {
            alertMessage(ALERT_TITLES.ERROR, res.message);
          }
        }
      }
    }
  };

  const handleDeactivate = async (reasons: any[], emailPromos: boolean) => {
    const deactivationData = {
      userId: auth.id,
      reasons,
      emailPromos,
      deactivatedAt: new Date().toISOString(),
    };

    setLoading(true);

    await deactivateUser(deactivationData);
  };

  const handleDeleteAccount = async (
    reasons: string[],
    otherReason?: string
  ): Promise<void> => {
    try {
      // Log the deletion reasons (in a real app, you would send this to your backend)
      const deactivationData = {
        reasons: reasons,
        otherReason: otherReason,
      };

      // Call the delete API
      await deleteUser(deactivationData);

    } catch (error) {
      console.error("Error deleting account:", error);
      throw error;
    }
  };

  const backdeModal = async () => {
    setShowDeactivateModal(false);
  };

  return (
    <>
      {loading && (
        <LoadingOverlay>
          <LoadingSpinner>
            <LoadingSpinnerIcon />
          </LoadingSpinner>
        </LoadingOverlay>
      )}
      <ShopDetailsContainer>
        <ProfileInfo>
          <ProfileDetailItem>
            <InfoTitle>Name</InfoTitle>
            <ProfileName>{formData.name}</ProfileName>
          </ProfileDetailItem>
          <ProfileDetailItem>
            <InfoTitle>Email</InfoTitle>
            <InfoDescription>{formData.email}</InfoDescription>
          </ProfileDetailItem>
          <ProfileDetailItem className="mb-8">
            <InfoTitle>Mobile Number</InfoTitle>
            <InfoDescription>+65 {formData.mobile}</InfoDescription>
          </ProfileDetailItem>

          <FormSubTitle $marginBottom="0">Deactivate Account</FormSubTitle>
          <DeactivateButton onClick={() => setShowDeactivateModal(true)}>
            <span className="mr-8">Deactivate Account</span>
            <img src={Info} alt="Info" />
          </DeactivateButton>

          <DeactivationModal
            open={showDeactivateModal}
            onClose={backdeModal}
            onConfirm={handleDeactivate}
          />

          <FormSubTitle $marginBottom="0">Delete Account</FormSubTitle>
          <DeactivateButton
            $width="90px"
            onClick={() => setShowDeleteModal(true)}
          >
            Delete
          </DeactivateButton>

          <DeleteAccountModal
            open={showDeleteModal}
            onClose={() => setShowDeleteModal(false)}
            onConfirm={handleDeleteAccount}
          />
        </ProfileInfo>
      </ShopDetailsContainer>
    </>
  );
};

export default MyProfile;
